import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

// import dashboardIcon from '../../src/assets/svg/admin_dashboard.svg'
Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    theme: {
        themes: {
            light: {
                primary: '#00CE81',
                /*secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',*/
            },
        },
    },
    // icons: {
    //     iconfont: 'fa',
    //     values: {
    //         customIconSvg: dashboardIcon,
    //         customIconSvgPath: 'M2.53,16.621H9.563l.005,0a.782.782,0,0,0,.111.007.418.418,0,0,0,.046-.009h6.319c.009,0,.016,0,.023,0l.005,0h7.039a.88.88,0,0,0,.88-.88A11.173,11.173,0,0,0,4,8.884.881.881,0,0,0,5.387,9.967a9.413,9.413,0,0,1,16.8,4.894H16.657a4.028,4.028,0,0,0-.841-1.434l1.677-2.306a.879.879,0,1,0-1.422-1.034l-1.714,2.357a4,4,0,0,0-1.536-.345,4.057,4.057,0,0,0-3.833,2.762H3.45a9.406,9.406,0,0,1,.41-2.016.88.88,0,0,0-1.675-.54,11.186,11.186,0,0,0-.535,3.436A.88.88,0,0,0,2.53,16.621Zm10.292-2.762a2.253,2.253,0,0,1,1.886,1H10.969A2.26,2.26,0,0,1,12.821,13.859Z',
    //     },
    // },

});
